module.exports = __webpack_public_path__ + "application/templates/forgot-password/forgot-password.template.html";